<ng-container
  [ngSwitch]="notification?.type"
  *ngIf="{isMobile: (isMobileViewService.isMobileView$() | async)} as mobileView"
>
  <div
    [routerLink]="['', { outlets: { modal: ['merge-candidate',
    notification.itemId] } }]"
    *ngSwitchCase="NotificationType.DUPLICATE"
    class="notification notification-duplicate"
    [ngClass]="{'unread':
    notification?.isRead === false}"
  >
    <common-mojo-avatar
      [avatarBackground]="avatarBackground"
      [id]="notification.data?.imageId"
      [initials]="notification.data?.initials"
      [label]="notification.data?.label"
      [selectedPhotoShape]="avatarPhotoShape"
      class="image"
    ></common-mojo-avatar>

    <div class="content">
      <span class="message">
        <strong class="name">
          <ng-container *ngIf="notification.data?.displayAnonymized; then
            anonymizedNameTemplate; else nonAnonymizedNameTemplate">
          </ng-container>
        </strong> might already exist in the system
        <div
          *ngIf="!mobileView.isMobile"
          class="time"
        >{{ notification.createdDate | timeDiff }}</div>
      </span>

      <span class="details">
        <div [ngClass]="{'d-flex': mobileView.isMobile}">
          <span
            *ngIf="mobileView.isMobile"
            class="time"
          >{{ notification.createdDate | timeDiff }}</span>
          <span
            class="type"
            data-cy="notifications-list-item-duplicate"
          >DUPLICATE</span>
        </div>
        <ng-container
          *ngIf="mobileView.isMobile; then hideNotificationMenuMobile; else hideNotificationBtn"
        >
        </ng-container>
      </span>
    </div>
  </div>
  <div
    *ngSwitchCase="NotificationType.INVITED_APPLIED"
    class="notification"
    [ngClass]="{'unread':
    notification?.isRead === false}"
  >
    <common-mojo-avatar
      [avatarBackground]="avatarBackground"
      [id]="notification.data?.imageId"
      [initials]="notification.data?.initials"
      [label]="notification.data?.label"
      [selectedPhotoShape]="avatarPhotoShape"
      class="image"
    ></common-mojo-avatar>
    <div class="content">
      <span class="message">
        <strong><a
            class="name highlight-notification"
            [routerLink]="['candidates', notification.data?.candidateId]"
          >
            {{ notification.data?.displayAnonymized ?
            notification.data?.anonymizedName : notification.data?.name }}</a>
        </strong>
        applied for
        <strong>
          <a
            class="name highlight-notification"
            [routerLink]="['jobs/job/' + notification.data?.jobId]"
          >
            {{ notification.data?.jobTitle }}</a>
        </strong>
        <div
          *ngIf="!mobileView.isMobile"
          class="time"
        >{{ notification.createdDate | timeDiff }}</div>
      </span>

      <span class="details">
        <div [ngClass]="{'d-flex': mobileView.isMobile}">
          <span
            *ngIf="mobileView.isMobile"
            class="time"
          >{{ notification.createdDate | timeDiff }}</span>
        </div>
        <ng-container
          *ngIf="mobileView.isMobile; then hideNotificationMenuMobile; else hideNotificationBtn"
        >
        </ng-container>
      </span>
    </div>
  </div>
  <div
    *ngSwitchCase="NotificationType.HIRING_MANAGER"
    class="notification notification-hiring-manager"
    [ngClass]="{'unread':
    notification?.isRead === false}"
  >
    <common-mojo-avatar
      [avatarBackground]="avatarBackground"
      [id]="notification.data?.imageId"
      [initials]="notification.data?.initials"
      [label]="notification.data?.label"
      [selectedPhotoShape]="avatarPhotoShape"
      class="image"
    ></common-mojo-avatar>
    <div class="content">
      <span class="message">
        <strong>{{ notification.data?.hiringManagerName }} </strong>
        {{ notification.data?.status }}
        <strong><a
            class="name hiring-manager-link"
            [routerLink]="['candidates', notification.data?.candidateId]"
          >
            {{ notification.data?.displayAnonymized ?
            notification.data?.anonymizedName : notification.data?.candName }}</a>
        </strong>
        for
        <strong>
          <a
            class="name hiring-manager-link"
            [routerLink]="['jobs/job/' + notification.data?.jobId +
            (notification.data?.status.includes('advanced') ? '/shortlist' :
                  notification.data?.status.includes('rejected') ? '/rejected-da' : '')
            ]"
          >
            {{ notification.data?.jobTitle }}</a>
        </strong>
        <div
          *ngIf="!mobileView.isMobile"
          class="time"
        >{{ notification.createdDate | timeDiff }}</div>
      </span>

      <span class="details">
        <div [ngClass]="{'d-flex': mobileView.isMobile}">
          <span
            *ngIf="mobileView.isMobile"
            class="time"
          >{{ notification.createdDate | timeDiff }}</span>
        </div>
        <ng-container
          *ngIf="mobileView.isMobile; then hideNotificationMenuMobile; else hideNotificationBtn"
        >
        </ng-container>
      </span>
    </div>
  </div>
  <div
    *ngSwitchCase="NotificationType.REFERRAL"
    class="notification"
    [ngClass]="{'unread': notification?.isRead === false}"
  >
    <common-mojo-avatar
      [avatarBackground]="avatarBackground"
      [id]="notification.data?.imageId"
      [initials]="notification.data?.initials"
      [label]="notification.data?.label"
      [selectedPhotoShape]="avatarPhotoShape"
      class="image"
    ></common-mojo-avatar>
    <div class="content">
      <span class="message">
        <strong><a
            class="name highlight-notification"
            [routerLink]="['candidates', notification.data?.candidateId]"
          >
            {{ notification.data?.displayAnonymized ?
          notification.data?.anonymizedName : notification.data?.candidateName }}</a>
        </strong>
        was submitted as an employee referral
        <span *ngIf="notification.data?.jobId">for</span>
        <strong *ngIf="notification.data?.jobId">
          <a
            class="name highlight-notification"
            [routerLink]="['jobs/job/' + notification.data?.jobId]"
          >
            {{ notification.data?.jobTitle }}</a>
        </strong>
        <div
          *ngIf="!mobileView.isMobile"
          class="time"
        >{{ notification.createdDate | timeDiff }}</div>
      </span>

      <span class="details">
        <div [ngClass]="{'d-flex': mobileView.isMobile}">
          <span
            *ngIf="mobileView.isMobile"
            class="time"
          >{{ notification.createdDate | timeDiff }}</span>
        </div>
        <ng-container
          *ngIf="mobileView.isMobile; then hideNotificationMenuMobile; else hideNotificationBtn"
        >
        </ng-container>
      </span>
    </div>
  </div>

  <div *ngSwitchCase="NotificationType.ASSIGN">
    <div>
      <div
        (click)="navidateAssign(notification?.data?.entityType, notification?.data?.entityId)"
        class="notification notification-duplicate"
        [ngClass]="{'unread':
        notification?.isRead === false}"
      >
        <common-mojo-avatar
          [avatarBackground]="avatarBackground"
          [initials]="'JM'"
          [selectedPhotoShape]="avatarPhotoShape"
          class="image"
        ></common-mojo-avatar>

        <div class="content">
          <span class="message">
            <strong class="name">
            </strong> You are assigned to the new task for
            <div
              [ngSwitch]="notification?.data?.entityType"
              style="display: flex;"
            >
              <div *ngSwitchCase="'CANDIDATE'">
                candidate &nbsp;
              </div>
              <div *ngSwitchCase="'JOB'">
                job &nbsp;
              </div>
              <div *ngSwitchCase="'TALENT_POOL'">
                talent pool &nbsp;
              </div>
              {{notification?.data?.entityName}}
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #hideNotificationBtn>
  <span
    *ngIf="!(isMobileViewService.isMobileView$() | async)"
    class="delete"
    (click)="hideNotification($event, notification.id)"
  >
    <mat-icon>delete</mat-icon>
  </span>
</ng-template>

<ng-template #hideNotificationMenuMobile>
  <span
    (click)="$event.stopPropagation()"
    class="more-button"
    [matMenuTriggerFor]="moreMenu"
    #trigger="matMenuTrigger"
    [ngClass]="{'active': trigger.menuOpened}"
    (menuOpened)="menuMarkForCheck()"
    (menuClosed)="menuMarkForCheck()"
  >
    <mat-icon
      class="more-icon"
      [ngClass]="{'active': trigger.menuOpen}"
    >more_horiz</mat-icon>
  </span>

  <mat-menu
    #moreMenu="matMenu"
    class="more-menu no-padding"
    xPosition="after"
  >
    <button
      mat-menu-item
      class="menu-button"
      (click)="hideNotification($event, notification.id)"
    >Delete
    </button>
  </mat-menu>
</ng-template>

<ng-template #anonymizedNameTemplate>
  {{notification.data?.anonymizedName}}
</ng-template>

<ng-template #nonAnonymizedNameTemplate>
  {{notification.data?.name === 'null null' ? '[This candidate]' :
  notification.data?.name}}
</ng-template>
